import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {tap} from 'rxjs/operators';
import {NotiFilters} from '../../../views/wrapper/payroll/notification/notifications/notifications';

@Injectable({
  providedIn: 'root'
})
export class JobService {

  private isLoading = false;

  newRequestSubject = new BehaviorSubject<boolean>(false);
  resetNewRequest = false;
  newRequest = false;

  constructor(
    private http: HttpClient
  ) {
  }

  checkHasNewJobApp(companyId: string): BehaviorSubject<boolean> {
    if (this.newRequest && !this.resetNewRequest) {
      this.newRequestSubject.next(this.newRequest);
    } else if (!this.isLoading || this.resetNewRequest) {
      this.isLoading = true;
      this.getCountJobApplication(companyId).subscribe((resp) => {
        let hasNew = false
        if (resp.data) {
          for (const [key, value] of Object.entries(resp.data)) {
            if (value['NEW'] && value['NEW'] > 0) {
              hasNew = true
              break
            }
          }
        }
        this.newRequest = hasNew
        this.isLoading = false;
        this.resetNewRequest = false;
        this.newRequestSubject.next(this.newRequest);
      },
      (err) => {
        console.log(err);
        this.isLoading = false;
        this.resetNewRequest = false;
        this.newRequestSubject.next(false);
      });
      return this.newRequestSubject;
    }
    return this.newRequestSubject;
  }

  getJobPosts(companyId: string, params: any): Observable<any> {
    return this.http.get(`${environment.jobBaseUrl}/${companyId}/job-posts`, {params: params});
  }
  getCountJobPosts(companyId: string): Observable<any> {
    return this.http.get(`${environment.jobBaseUrl}/${companyId}/job-posts/count-by-status`);
  }
  createJobPost(companyId: string, body: any): Observable<any> {
    return this.http.post(`${environment.jobBaseUrl}/${companyId}/job-posts`, body);
  }
  updateJobPost(companyId: string, jobId: string, body: any): Observable<any> {
    return this.http.put(`${environment.jobBaseUrl}/${companyId}/job-posts/${jobId}`, body);
  }
  updateJobPostStatus(companyId: string, jobId: string, body: any): Observable<any> {
    return this.http.put(`${environment.jobBaseUrl}/${companyId}/job-posts/${jobId}/status`, body);
  }
  deleteJobPost(companyId: string, jobId: string): Observable<any> {
    return this.http.delete(`${environment.jobBaseUrl}/${companyId}/job-posts/${jobId}`);
  }
  
  getJobApplication(companyId: string, params: any): Observable<any> {
    return this.http.get(`${environment.jobBaseUrl}/${companyId}/job-applications`, {params: params});
  }
  getCountJobApplication(companyId: string): Observable<any> {
    return this.http.get(`${environment.jobBaseUrl}/${companyId}/job-applications/count-by-job-post`);
  }

  rejectJobApplication(companyId: string, jobAppId: string): Observable<any> {
    return this.http.post(`${environment.jobBaseUrl}/${companyId}/job-applications/${jobAppId}/reject`, null).pipe(
      tap(() => {
        this.resetNewRequest = true;
        this.checkHasNewJobApp(companyId);
      })
    );
  }
  offerJobApplication(companyId: string, jobAppId: string): Observable<any> {
    return this.http.post(`${environment.jobBaseUrl}/${companyId}/job-applications/${jobAppId}/offer`, null).pipe(
      tap(() => {
        this.resetNewRequest = true;
        this.checkHasNewJobApp(companyId);
      })
    );
  }

  createJobApplicationSelfOnboard(companyId: string, jobAppId: string, body: any): Observable<any> {
    return this.http.post(`${environment.jobBaseUrl}/${companyId}/job-applications/${jobAppId}/self-onboarding-employee`, body);
  }
  deleteJobApplication(companyId: string, jobAppId: string): Observable<any> {
    return this.http.delete(`${environment.jobBaseUrl}/${companyId}/job-applications/${jobAppId}`);
  }

}